// Third-party libraries
import React, { useContext, useState } from "react";

// Local modules
import { storage } from "../../utils";
import { GemstoneSearchContext } from "../../utils/stateHandlers/contexts";
import AccordionGemstoneFilter from "./AccordionGemstoneFilter";
import GemstoneFilter from "./GemstoneFilter";
import useMediaQueryUtils from "../../utils/mediaQueryUtils";

export default function GemstoneFilters(props) {
  const isMdScreen = useMediaQueryUtils("md");
  const { gemstoneState, dispatch } = useContext(GemstoneSearchContext);
  const { searchQuery, filters } = gemstoneState;
  const [localFcIntensity, setLocalFcIntensity] = useState(["None"]);
  const loggedIn = storage.getStorageItem("authToken");
  const valuesForColor = searchQuery.fields.find(
    (field) => field.name === "Collection"
  );

  const valueForColor = valuesForColor?.values?.[0]?.name || "All Gemstones";

  function updateFilters(filterName, filterValues) {
    const filterToUpdate = searchQuery.fields.find(function (field) {
      return field.name === filterName;
    });
    const rangeOrValues =
      filterName === "HooverPrice" ||
      filterName === "Carat" ||
      filterName === "LWRatio" ||
      filterName === "Table" ||
      filterName === "Depth"
        ? "range"
        : "values";
    if (filterName === "Collection") {
      clearFilters();
    }
    if (filterToUpdate) {
      if (rangeOrValues === "range") {
        filterToUpdate.range = filterValues;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      } else {
        filterToUpdate.values = filterValues;
        if (filterToUpdate.values.length === 0) {
          let newFields = searchQuery.fields.map((field) => ({
            ...field,
            values: [...field.values],
          }));
          newFields = newFields.filter((field) => field.name !== filterName);
          dispatch({ type: "updateSearchQuery", payload: newFields });
        } else {
          dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
        }
      }
    } else {
      if (rangeOrValues === "range") {
        const fields = searchQuery.fields.concat({
          name: filterName,
          range: filterValues,
        });
        dispatch({ type: "updateSearchQuery", payload: fields });
      } else {
        const fields = searchQuery.fields.concat({
          name: filterName,
          values: filterValues,
        });
        dispatch({ type: "updateSearchQuery", payload: fields });
      }
    }
  }

  function clearFilters(collection) {
    dispatch({
      type: "clearFilters",
      payload: [collection],
    });
    dispatch({
      type: "updateSort",
      payload: {
        sortField: "Carat",
        sortDirection: "desc",
      },
    });
  }

  function updateCheckedBoxes(filterName, values) {
    if (filterName === "ShipsSameDay" || filterName === "ImageVideoAvailable") {
      if (values.checked === "N") {
        const newSearchQuery = searchQuery.fields.filter(function (queryField) {
          return queryField.name !== filterName;
        });
        dispatch({ type: "updateSearchQuery", payload: newSearchQuery });
      } else {
        updateFilters(filterName, [{ name: values.checked }]);
      }
    } else {
      const searchValues = values
        .filter(function (value) {
          return value.checked === true;
        })
        .map(function (value) {
          return { name: value.name };
        });
      updateFilters(filterName, searchValues);
    }
  }

  function updateRange(filterName, range) {
    updateFilters(filterName, range);
  }

  function updateNominalRange(filterName, marks, sliderValue) {
    const newArray = marks
      .filter(
        (m) => m.value + 0.1 > sliderValue[0] && m.value + 0.1 < sliderValue[1]
      )
      .map((m) => {
        return { name: m.label };
      });
    updateFilters(filterName, newArray);
  }

  return (
    <>
      {isMdScreen ? (
        <AccordionGemstoneFilter
          collection={props.collection}
          updateCheckedBoxes={updateCheckedBoxes}
          localFcIntensity={localFcIntensity}
          setLocalFcIntensity={setLocalFcIntensity}
          updateNominalRange={updateNominalRange}
          valueForColor={valueForColor}
          updateRange={updateRange}
          loggedIn={loggedIn}
          clearFilters={clearFilters}
          gemstoneState={gemstoneState}
          dispatch={dispatch}
          filters={filters}
          searchQuery={searchQuery}
        />
      ) : (
        <GemstoneFilter
          collection={props.collection}
          updateCheckedBoxes={updateCheckedBoxes}
          localFcIntensity={localFcIntensity}
          setLocalFcIntensity={setLocalFcIntensity}
          updateNominalRange={updateNominalRange}
          valueForColor={valueForColor}
          updateRange={updateRange}
          loggedIn={loggedIn}
          clearFilters={clearFilters}
          setImageToggle={props.setImageToggle}
          imageToggle={props.imageToggle}
        />
      )}
    </>
  );
}
